import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { CustomWidthTooltip } from '../containers/ccsmodule/queues/settings/componenets/settingsBlock';
import Dropdown from './dropdown';


const Counter = (props: any) => {
  const { node, data, change } = props
  const [count, setCount] = useState(1);
  const handleCounter = (type: string) => {
    let copyData = [...data]
    copyData?.map((child: any) => {
      if (node?.name === child?.name) {
        if (type === 'decrement' && node?.value > 0) {
          node.value = node?.value - 1
        } else if (type === 'increament') {
          setCount(count + 1)
          node.value = node?.value + 1
        }
      }
      return node

    })
    change([...copyData])
    if (type === 'decrement' && count > 0) {
      setCount(count - 1)
    }
    else if (type === 'increament') {
      setCount(count + 1)

    }
  }

  useEffect(() => {

    if (node?.value === 0) {
      let copy = [...dropdownData]
      copy[0].value = "unlimited"
      setDropdownData(copy)
    } else {
      let copy = [...dropdownData]
      copy[0].value = "custom"
      setDropdownData(copy)
    }
    console.log("node?.valuee", node?.value)
  }, [node?.value])






  const dropDownCallback = (value: string) => {
    console.log("kajsdbkajbdskjabd", value)
    switch (value) {
      case "unlimited":
        break;
      case "custom":
        handleCounter("increament")

        break
      default:
        break;
    }

  }

  const [dropdownData, setDropdownData] = useState([{
    title: 'Maximum Callers in Queue',
    name: 'distribution',
    type: 'dropdown',
    Callback: dropDownCallback,
    displayProps: { "label": "label", "value": "value" },
    childrens: [{ label: 'No Limit', value: "unlimited" }, { label: 'Custom', value: 'custom' }],
    value: '',
    required: true,
    errormessage: "Distribution Strategy is required"
  }])


  const returnFilteredData = (value: string) => {
    return dropdownData?.filter((node: { name: string }) => node?.name === value)[0]
  }






  return (

    dropdownData[0]?.value === "custom" ?
      <div className={` relative  p-2 `}>
        <RemoveIcon onClick={() => handleCounter('decrement')} className=' absolute top-6 left-6 cursor-pointer z-10' />
        <TextField
          sx={{ width: "100%" }}
          id={`counter-outlined-number`}
          label={node?.title}
          type="text"
          defaultValue={1}
          value={node?.value}
          disabled={true}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <AddIcon onClick={() => handleCounter('increament')} className=' absolute top-6 right-8 cursor-pointer' />
      </div>
      :
      <Dropdown key={"distribution"} node={returnFilteredData("distribution")} data={dropdownData} change={setDropdownData} />

  )
}

export default Counter


